import React, { useEffect, useState } from 'react'
import {
  Container,
  Nav,
  Navbar,
  Col,
  Row,
  Button,
  Form,
  FormControl,
  InputGroup,
  Stack,
  Modal
} from "react-bootstrap";
import Header from "../Header";
import Footer from "../Footer";
import { NavLink, Link, useHistory } from "react-router-dom";
import { Auth } from '../../Services/Auth';
import { NotificationManager } from 'react-notifications';
import GoogleLogin from '../GoogleLogin';
import FbLogin from '../FBLogin';
import { setAppState } from '../../helpers/app_state';
import ForgotPassword from '../ForgotPassword';

function OrgLogin() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(false);
  let history = useHistory();
  let type = 'company'

  const [validated, setValidated] = useState(false);
  const afterLoginSuccess = () => {
    history.push('/organization-dashboard');
  }
  const afterLoginFailed = (socialData) => {
    history.push({
      pathname: '/organization-registration',
      state: socialData
    });
  }
  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
    Auth.login({ email: event.target.email.value, password: event.target.password.value, type: type }).then(
      (data) => {
        if (!data.errors) {
          setAppState(data)
          NotificationManager.success(data.message, 'success!', 2000);
          setMessage(data.message)
          history.push('/organization-dashboard');
        } else {
          NotificationManager.error(data.message, 'error!', 2000);
        }


      },
      (error) => {
        NotificationManager.error(error.toString(), 'error!', 2000);
        setError(error.toString())
      }
    )
  };

  return (
    <>
      <Header />
      <section style={{ height: '100vh', width: 'auto' }}>
        <div className="login-body" style={{ backgroundImage: 'url("images/login-bg.jpg")', height: '100%', width: 'auto', backgroundPosition: 'center' }}>
          <Container>
            <Row className="justify-content-end">
              <Col md={5}>
                <div className="login-box">
                  <div className="tab-menu seprator">
                    <ul>
                      <li className="active" style={{ width: "100%" }}>
                        <Link style={{ fontSize: '25px' }} to="/organization">
                          Organization
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="login-box-body">
                    {/* <h4>Login to your account</h4> */}
                    <h4 className="text-center">Log in to your account</h4>
                    {/* <div className="login-with">
                      <ul>
                        <li>
                          <GoogleLogin type={type} afterLoginSuccess={afterLoginSuccess} afterLoginFailed={afterLoginFailed} />
                        </li>
                        <li>
                          <FbLogin type={type} afterLoginSuccess={afterLoginSuccess} afterLoginFailed={afterLoginFailed} />
                        </li>
                      </ul>
                    </div>
                    <div className="or">OR</div> */}
                    <p></p>
                    <p>Thank you for being a part of Dasya! Log in using your Email given to you by team at Dasya.</p>
                    <Form noValidate validated={validated} onSubmit={handleSubmit}>
                      <Row>
                        <Form.Group className="form-group mb-3" as={Col} md="12" controlId="validationCustom01">
                          <Form.Control
                            required
                            type="email"
                            name="email"
                            placeholder="Company Email"
                            defaultValue=""
                          />
                          <span className="form-icon">
                            <img src="/images/user-icon.png" alt="" />
                          </span>
                        </Form.Group>
                        <Form.Group className="form-group mb-3" as={Col} md="12" controlId="validationCustom01">
                          <Form.Control
                            required
                            type="password"
                            name="password"
                            placeholder="Password"
                            defaultValue=""
                          />
                          <span className="form-icon">
                            <img src="/images/pass-icon.png" alt="" />
                          </span>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Col md={6}>
                          <Form.Check className="remember"
                            type="checkbox"
                            label="Remember Me"
                            id="remember"
                          />
                        </Col>
                        <Col md={6} className="text-end">
                          <a href="javascript:void(0)" className="forgot" onClick={handleShow}>Forgot Password?</a>
                        </Col>
                      </Row>
                      <Stack className="col-md-12 mt-4 mb-3">
                        <Button variant="primary" type="submit">Log in To Your Account</Button>
                      </Stack>
                      <p className="not-member">Not a member yet? <Link to="/organization-registration">Register Now</Link></p>
                    </Form>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
      <ForgotPassword show={show} handleClose={handleClose} />
      {/* <Modal show={show} onHide={handleClose}
        size="sm"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Forgot Password?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center mb-3">
            <img src="/images/lock-pass-icon.png" alt="" width="79.4" />
          </div>
          <p className="modal-text text-center">
            Unfortunately we are unable to validate your account. Since this is a single sign-on kindly contact Dasya to reset your password.
          </p>
          <div className="text-center">
            <Button variant="primary" onClick={handleClose} className="px-5">
              Okay
            </Button>
          </div>
        </Modal.Body>
      </Modal> */}
      <Footer />
    </>
  )
}

export default OrgLogin
